/**
 * deSal — India hard-water map intro (additive, non-breaking).
 *
 * Runs ONCE the first time the map scrolls into view (desktop only):
 *   1. A water-glow lights up India's OUTER border and stays (group drop-shadow).
 *   2. Tooltips auto-tour the states one-by-one in random order.
 * Any real user hover/click/tap stops everything and restores full control.
 *
 * This file never touches india-hardwater-map.js — it only dispatches the same
 * events a user would, and reads/animates the rendered SVG. If anything fails,
 * the map keeps working normally.
 */
(function () {
  'use strict';

  var mount = document.getElementById('india-hardwater-map');
  if (!mount) return;

  var DESKTOP = window.matchMedia('(min-width: 750px)');

  var started = false;
  var stopped = false;
  var cycleTimer = null;
  var activePath = null;
  var box = null;
  var svgEl = null;

  function states() {
    return svgEl
      ? Array.prototype.slice.call(svgEl.querySelectorAll('path[data-name]'))
      : [];
  }

  function fireMouse(type, path, x, y) {
    try {
      path.dispatchEvent(
        new MouseEvent(type, {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: x || 0,
          clientY: y || 0
        })
      );
    } catch (e) {
      /* no-op */
    }
  }

  function showState(path) {
    var r = path.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    fireMouse('mouseover', path, cx, cy);
    fireMouse('mousemove', path, cx, cy);
  }

  function hideState(path) {
    fireMouse('mouseout', path, 0, 0);
  }

  /* 1) Glow around India's OUTER border only.
        A drop-shadow on the whole group hugs the combined silhouette (the
        outer coastline/boundary). Internal state borders stay untouched
        because the filled states form one solid shape. The glow fades in
        on first view, holds, then fades back out after ~10s. */
  function borderShine() {
    var g = document.getElementById('ihm-g') || svgEl;
    if (!g) return;
    var OFF =
      'drop-shadow(0 0 0 rgba(127, 233, 217, 0)) drop-shadow(0 0 0 rgba(66, 127, 134, 0))';
    var GLOW =
      'drop-shadow(0 0 2px rgba(127, 233, 217, 1)) drop-shadow(0 0 12px rgba(66, 127, 134, 0.6))';
    g.style.transition = 'filter 1.1s ease';
    g.style.filter = OFF;
    void g.getBoundingClientRect(); // reflow so the transition has a start value
    requestAnimationFrame(function () {
      g.style.filter = GLOW;
    });
    setTimeout(function () {
      g.style.filter = OFF; // fade out after 10s
    }, 10000);
  }

  function tipEl() {
    return document.getElementById('ihm-tip');
  }

  function fadeTip(o) {
    var tip = tipEl();
    if (tip) tip.style.opacity = String(o);
  }

  /* Un-highlight a state without hiding the tooltip (mouseout would hide it). */
  function resetPath(p) {
    if (!p) return;
    p.style.opacity = '1';
    p.setAttribute('stroke', '#fff');
    p.setAttribute('stroke-width', '0.6');
  }

  /* 2) Auto-tour the tooltips in random order, until the user takes over.
        Each tooltip fades out -> content/position swaps while invisible ->
        fades back in, and lingers, so nothing changes abruptly. */
  function startTour() {
    if (stopped) return;
    var paths = states();
    if (!paths.length) return;

    for (var i = paths.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = paths[i];
      paths[i] = paths[j];
      paths[j] = t;
    }

    var DWELL = 2800; // how long each tooltip lingers
    var FADE = 450; // fade out/in duration (matches the tip's CSS transition)
    var idx = 0;

    function step() {
      if (stopped) return;
      fadeTip(0);
      cycleTimer = setTimeout(function () {
        if (stopped) return;
        if (activePath) resetPath(activePath);
        activePath = paths[idx % paths.length];
        idx++;
        showState(activePath); // fills content + highlights while invisible
        fadeTip(1);
        cycleTimer = setTimeout(step, DWELL);
      }, FADE);
    }

    cycleTimer = setTimeout(step, 200);
  }

  function stop() {
    if (stopped) return;
    stopped = true;
    if (cycleTimer) clearTimeout(cycleTimer);
    if (activePath) {
      hideState(activePath);
      activePath = null;
    }
    var tip = tipEl();
    if (tip) tip.style.opacity = ''; // restore default for real hovers
  }

  function onRealInteract(e) {
    if (e && e.isTrusted === false) return; // ignore our own synthetic events
    stop();
  }

  function run() {
    if (started || !DESKTOP.matches) return;
    started = true;

    var tip = tipEl();
    if (tip) {
      tip.style.transition = 'opacity 0.45s ease';
      tip.style.opacity = '0';
    }

    ['pointerdown', 'click', 'touchstart', 'mouseover'].forEach(function (type) {
      mount.addEventListener(type, onRealInteract, { passive: true });
    });

    borderShine();
    setTimeout(function () {
      if (!stopped) startTour();
    }, 2000);
  }

  /* Wait for the async-rendered SVG, then arm the intro on first scroll-in. */
  (function whenReady() {
    var tries = 0;
    (function poll() {
      box = document.getElementById('ihm-box');
      svgEl = box ? box.querySelector('svg') : null;
      if (svgEl && svgEl.querySelector('path[data-name]')) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (en) {
                if (en.isIntersecting) {
                  io.disconnect();
                  run();
                }
              });
            },
            { threshold: 0.4 }
          );
          io.observe(mount);
        } else {
          run();
        }
        return;
      }
      if (tries++ < 80) setTimeout(poll, 200);
    })();
  })();
})();
